import { ref, watch } from 'vue';
import { defineStore } from 'pinia';
import {
  getLocalStorageItem,
  setLocalStorageItem,
  SETTINGS_FAVORITE_TAGS,
} from '@/stores/localStorage';

export const useFavoriteTagsStore = defineStore('favoriteTags', () => {
  const tags = ref<string[]>(getLocalStorageItem(SETTINGS_FAVORITE_TAGS, []));
  watch(tags, (v) => setLocalStorageItem(SETTINGS_FAVORITE_TAGS, v), { deep: true });

  function add(tag: string) {
    if (tag && !tags.value.includes(tag)) {
      tags.value.push(tag);
    }
  }

  function remove(tag: string) {
    tags.value = tags.value.filter((t) => t !== tag);
  }

  function isFavorite(tag: string): boolean {
    return tags.value.includes(tag);
  }

  function toggle(tag: string) {
    if (isFavorite(tag)) remove(tag);
    else add(tag);
  }

  return {
 tags,
add,
remove,
isFavorite,
toggle,
};
});
